import React from "react";
import { useTenant } from "../api/helpers";

const Line = () => {
  const tenant = useTenant();

  return (
    <div>
      <style jsx>{`
        div {
          height: 1px;
          width: 100%;
          background: ${tenant?.color};
        }
      `}</style>
    </div>
  );
};

export default Line;
